import React, { useState, useEffect } from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import classNames from 'classnames';

import styles from './plannavmobile.module.css';

export const PlanNavMobile = ({ items, activeScroll }) => {
  const [clickedTrigger, setClickedTrigger] = useState(false);
  const [active, setActive] = useState();
  const [focused, setFocused] = useState('doctor_visits');
  const [prevView, setPrevView] = useState(false);
  const [nextView, setNextView] = useState(true);

  useEffect(() => {
    if (clickedTrigger === true) {
      setTimeout(() => {
        setClickedTrigger(false);
      }, 1300);
      return;
    }

    if (activeScroll) {
      setActive(activeScroll);
      setFocused(activeScroll);

      const currentButton = document.querySelector(
        `[data-nav="${activeScroll}"]`
      );

      if (activeScroll === 'doctor_visits') {
        document.getElementById('mobileButtons').scroll({
          left: currentButton?.offsetLeft - 98,
          behavior: 'smooth',
        });
      } else {
        document.getElementById('mobileButtons').scroll({
          left: currentButton?.offsetLeft - 68,
          behavior: 'smooth',
        });
      }
    }
  }, [activeScroll]);

  const checkArrowNeed = () => {
    if (focused === 'doctor_visits') {
      setPrevView(false);
    } else {
      setPrevView(true);
    }

    if (focused === 'footnotes') {
      setNextView(false);
    } else {
      setNextView(true);
    }
  };

  useEffect(() => {
    checkArrowNeed();
  }, [focused]);

  const positionOverflow = (button) => {
    document.getElementById('mobileButtons').scroll({
      left: button.currentTarget?.offsetLeft - 68,
      behavior: 'smooth',
    });
  };

  const prevNav = () => {
    const currentButton = document.querySelector(`[data-nav="${focused}"]`);
    const prevButton = currentButton?.previousSibling;
    const prevAttr = prevButton?.getAttribute('data-nav');

    if (prevButton) {
      if (prevAttr === 'doctor_visits') {
        document.getElementById('mobileButtons').scroll({
          left: prevButton?.offsetLeft - 98,
          behavior: 'smooth',
        });
      } else {
        document.getElementById('mobileButtons').scroll({
          left: prevButton?.offsetLeft - 68,
          behavior: 'smooth',
        });
      }

      setFocused(prevAttr);
    }
  };

  const nextNav = () => {
    const currentButton = document.querySelector(`[data-nav="${focused}"]`);
    const nextButton = currentButton?.nextSibling;
    const nextAttr = nextButton?.getAttribute('data-nav');

    if (nextButton) {
      document.getElementById('mobileButtons').scroll({
        left: nextButton?.offsetLeft - 68,
        behavior: 'smooth',
      });

      setFocused(nextAttr);
    }
  };

  return (
    <div className={styles.mobileButtons} id="mobileButtons">
      {prevView && (
        <button
          type="button"
          className={classNames(styles.mobileArrow, styles.mobileLeft)}
          onClick={() => {
            prevNav();
          }}
        >
          previous
        </button>
      )}
      <div className={styles.jump}>Jump To:</div>
      <div className={styles.navButtons}>
        {items.map((section, index) => {
          return (
            <button
              type="button"
              className={classNames(
                styles.planSideButton,
                active === section.value ? styles.isActive : ''
              )}
              data-nav={section.value}
              onClick={(e) => {
                setClickedTrigger(true);
                document
                  .getElementById(section.value)
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

                positionOverflow(e);

                setFocused(section.value);
                setActive(section.value);
              }}
              key={section.value}
            >
              {section.title}
            </button>
          );
        })}
      </div>
      {nextView && (
        <button
          type="button"
          className={classNames(styles.mobileArrow, styles.mobileRight)}
          onClick={() => {
            nextNav();
          }}
        >
          next
        </button>
      )}
    </div>
  );
};
